/**
 * Canopy configurator total: default variant price + addon add/remove
 * Updates ALL .totalprice_withaddone elements (2 places on page)
 *
 * Load FIRST before canopy-configurator.js
 * Requires: window.productJson = {{ product | json }};
 */
(function () {
  function getMoneyFormat() {
    return window.Shopify && window.Shopify.money_format
      ? window.Shopify.money_format
      : '${{amount}}';
  }

  function getCommaMoneyFormat() {
    const base = getMoneyFormat();
    if (base.includes('amount_with_comma_separator')) return base;
    return base.replace(/\{\{amount\}\}/g, '{{amount_with_comma_separator}}');
  }

  function formatMoneyAmount(cents) {
    cents = Math.round(Number(cents) || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const formatted = window.Shopify.formatMoney(cents, getCommaMoneyFormat());
      return formatted.replace(/[^\d,.-]/g, '').trim();
    }

    return (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, getCommaMoneyFormat());
    }

    return '$' + formatMoneyAmount(cents);
  }

  function getVariantPriceMap() {
    if (window.variantPriceMap && typeof window.variantPriceMap === 'object') {
      return window.variantPriceMap;
    }

    const map = {};
    const productJson = window.productJson;

    if (productJson && productJson.variants) {
      productJson.variants.forEach(function (variant) {
        map[String(variant.id)] = Number(variant.price) || 0;
      });
    }

    window.variantPriceMap = map;
    return map;
  }

  function isKnownVariantId(id) {
    if (id == null || id === '') return false;
    return Object.prototype.hasOwnProperty.call(getVariantPriceMap(), String(id));
  }

  function findVariantIdByLabel(value) {
    if (!value) return null;

    const needle = String(value).trim().toLowerCase();
    const productJson = window.productJson;

    if (!productJson || !productJson.variants) return null;

    for (let i = 0; i < productJson.variants.length; i++) {
      const variant = productJson.variants[i];
      const id = String(variant.id);

      if (id === needle) return id;

      const fields = [variant.title, variant.public_title, variant.option1, variant.option2, variant.option3];

      for (let j = 0; j < fields.length; j++) {
        if (fields[j] && String(fields[j]).trim().toLowerCase() === needle) {
          return id;
        }
      }
    }

    return null;
  }

  function resolveVariantId(candidate) {
    if (candidate == null || candidate === '') return null;

    const raw = String(candidate).trim();

    if (isKnownVariantId(raw)) return raw;

    if (/^\d+$/.test(raw) && isKnownVariantId(raw)) return raw;

    const fromLabel = findVariantIdByLabel(raw);
    if (fromLabel) return fromLabel;

    return null;
  }

  function getStep1RadioVariantId(radio) {
    if (!radio) return null;

    const candidates = [
      radio.dataset.variantId,
      radio.getAttribute('data-variant-id'),
      radio.dataset.id,
      radio.value
    ];

    for (let i = 0; i < candidates.length; i++) {
      const resolved = resolveVariantId(candidates[i]);
      if (resolved) return resolved;
    }

    const label =
      (radio.id && document.querySelector('label[for="' + radio.id + '"]')) ||
      radio.closest('label.cd-custom-varient');

    if (label) {
      const titleEl = label.querySelector('.variant-swatch-label');
      if (titleEl) {
        const titleText = titleEl.childNodes[0]
          ? titleEl.childNodes[0].textContent.trim()
          : titleEl.textContent.trim();
        const fromTitle = findVariantIdByLabel(titleText);
        if (fromTitle) return fromTitle;
      }
    }

    return null;
  }

  function getVariantIdEl() {
    const form =
      document.querySelector('form[action^="/cart/add"]') ||
      document.querySelector('product-form form');

    if (form) {
      const inForm = form.querySelector('[name="id"]');
      if (inForm) return inForm;
    }

    return (
      document.querySelector('form[action^="/cart/add"] [name="id"]') ||
      document.querySelector('product-form form [name="id"]')
    );
  }

  function getStep1Root() {
    const step1 = document.getElementById('step1');
    if (step1) return step1;

    const fieldsets = document.querySelectorAll('fieldset.product-form__input');
    for (let i = 0; i < fieldsets.length; i++) {
      const legend = fieldsets[i].querySelector('legend.form__label');
      if (legend && /choose your van/i.test(legend.textContent)) {
        return fieldsets[i];
      }
    }

    return null;
  }

  function getStep1VariantId() {
    const root = getStep1Root();
    if (!root) return null;

    const radio =
      root.querySelector('.cd-custom-varient input[type="radio"]:checked:not(.addon-checkbox)') ||
      root.querySelector('input[type="radio"]:checked:not(.addon-checkbox)') ||
      root.querySelector('input[type="radio"]:not(.addon-checkbox)');

    return getStep1RadioVariantId(radio);
  }

  function getFormVariantId() {
    const el = getVariantIdEl();
    if (!el) return null;

    let candidate = null;

    if (el.tagName === 'SELECT') candidate = el.value;
    else if (el.type === 'hidden') candidate = el.value;
    else {
      const checked = document.querySelector(
        'form[action^="/cart/add"] input[name="id"]:checked, product-form input[name="id"]:checked'
      );
      candidate = checked ? checked.value : el.value;
    }

    return resolveVariantId(candidate);
  }

  function getDefaultVariantId() {
    if (window.defaultVariantId) {
      return resolveVariantId(window.defaultVariantId);
    }

    const productJson = window.productJson;
    if (!productJson) return null;

    if (productJson.selected_or_first_available_variant) {
      return resolveVariantId(productJson.selected_or_first_available_variant.id);
    }

    if (productJson.selected_variant) {
      return resolveVariantId(productJson.selected_variant.id);
    }

    if (productJson.variants && productJson.variants.length) {
      const available = productJson.variants.find(function (v) { return v.available; });
      return resolveVariantId((available || productJson.variants[0]).id);
    }

    return null;
  }

  function getCurrentVariantId() {
    return getStep1VariantId() || getFormVariantId() || getDefaultVariantId();
  }

  function parsePriceToCents(raw) {
    if (raw == null || raw === '') return 0;

    if (typeof raw === 'number') {
      return raw > 1000 ? Math.round(raw) : Math.round(raw * 100);
    }

    const str = String(raw).replace(/[^0-9.]/g, '');
    const num = parseFloat(str);
    if (isNaN(num)) return 0;

    return Math.round(num * 100);
  }

  function getBaseVariantCentsFromDOM() {
    const root = getStep1Root();
    if (!root) return 0;

    const radio =
      root.querySelector('input[type="radio"]:checked:not(.addon-checkbox)') ||
      root.querySelector('input[type="radio"]:not(.addon-checkbox)');

    if (!radio) return 0;

    const label =
      (radio.id && root.querySelector('label[for="' + radio.id + '"]')) ||
      radio.closest('label.cd-custom-varient');

    if (!label) return 0;

    const priceEl = label.querySelector('.varinet-price, .cd-addon-option-price');
    if (priceEl) return parsePriceToCents(priceEl.textContent);

    return 0;
  }

  function getBaseVariantCents() {
    const id = getCurrentVariantId();

    if (id) {
      const fromMap = getVariantPriceMap()[String(id)];
      if (fromMap) return fromMap;
    }

    return getBaseVariantCentsFromDOM();
  }

  function getAddonTotalCents() {
    let total = 0;

    document.querySelectorAll('.addon-checkbox:checked').forEach(function (cb) {
      let cents = 0;

      if (cb.dataset.price != null && cb.dataset.price !== '') {
        cents = parsePriceToCents(cb.dataset.price);
      } else {
        const box = cb.closest('.option-box');
        const priceEl = box ? box.querySelector('.cd-addon-option-price') : null;
        if (priceEl) cents = parsePriceToCents(priceEl.textContent);
      }

      total += cents;
    });

    return total;
  }

  function syncFormVariantFromStep1() {
    const root = getStep1Root();
    const idEl = getVariantIdEl();
    if (!idEl) return getCurrentVariantId();

    const radio = root
      ? root.querySelector('input[type="radio"]:checked:not(.addon-checkbox)') ||
        root.querySelector('input[type="radio"]:not(.addon-checkbox)')
      : null;

    const variantId = getStep1RadioVariantId(radio) || getDefaultVariantId();

    if (!variantId) return null;

    if (idEl.tagName === 'SELECT') {
      idEl.value = variantId;
    } else if (idEl.type === 'radio') {
      const form = idEl.closest('form');
      if (form) {
        form.querySelectorAll('input[name="id"]').forEach(function (input) {
          input.checked = input.value === String(variantId);
        });
      }
    } else {
      idEl.value = variantId;
    }

    idEl.dispatchEvent(new Event('change', { bubbles: true }));
    return String(variantId);
  }

  function updateTotalUI() {
    const totalEls = document.querySelectorAll('.totalprice_withaddone');
    if (!totalEls.length) return;

    const basePrice = getBaseVariantCents();
    const addonPrice = getAddonTotalCents();
    const totalPrice = basePrice + addonPrice;
    const formatted = formatMoneyAmount(totalPrice);

    totalEls.forEach(function (el) {
      el.textContent = formatted;

      const wrapper = el.closest('.cd-addon-price-update');
      if (wrapper && totalPrice > 0 && !wrapper.dataset.keepHidden) {
        wrapper.style.display = '';
        wrapper.removeAttribute('hidden');
      }
    });
  }

  function showPopupTotalPrice() {
    const allPrices = document.querySelectorAll('.cd-addon-price-update');
    if (allPrices.length > 1) {
      allPrices[1].style.display = '';
      allPrices[1].removeAttribute('hidden');
    }
    updateTotalUI();
  }

  function bindPriceListeners() {
    document.addEventListener('change', function (e) {
      if (
        e.target.classList.contains('addon-checkbox') ||
        e.target.matches('#step1 input[type="radio"]') ||
        e.target.matches('#step1 .cd-custom-varient input[type="radio"]') ||
        e.target.matches('[name="id"]')
      ) {
        if (
          e.target.matches('#step1 input[type="radio"]') ||
          e.target.matches('#step1 .cd-custom-varient input[type="radio"]')
        ) {
          syncFormVariantFromStep1();
        }
        updateTotalUI();
      }
    });

    document.addEventListener('variant:change', updateTotalUI);

    const idEl = getVariantIdEl();
    if (idEl) {
      let lastValue = idEl.value;
      setInterval(function () {
        if (idEl.value !== lastValue) {
          lastValue = idEl.value;
          updateTotalUI();
        }
      }, 300);
    }
  }

  window.formatMoney = formatMoney;
  window.formatMoneyAmount = formatMoneyAmount;
  window.getBaseVariantCents = getBaseVariantCents;
  window.getAddonTotalCents = getAddonTotalCents;
  window.getCurrentVariantId = getCurrentVariantId;
  window.resolveVariantId = resolveVariantId;
  window.updateTotalUI = updateTotalUI;
  window.showPopupTotalPrice = showPopupTotalPrice;
  window.syncFormVariantFromStep1 = syncFormVariantFromStep1;

  function initPrice() {
    syncFormVariantFromStep1();
    updateTotalUI();
    setTimeout(updateTotalUI, 100);
    setTimeout(updateTotalUI, 400);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindPriceListeners();
    initPrice();
  });

  if (document.readyState !== 'loading') {
    bindPriceListeners();
    initPrice();
  }
})();
